import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c4af5c6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "account-container"
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { class: "account-container-body" }
const _hoisted_5 = { class: "lm-row" }
const _hoisted_6 = { class: "lm-column" }
const _hoisted_7 = { class: "account-info" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "Company", -1))
const _hoisted_9 = { class: "lm-column" }
const _hoisted_10 = { class: "account-info" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "VAT", -1))
const _hoisted_12 = { class: "lm-row" }
const _hoisted_13 = { class: "lm-column" }
const _hoisted_14 = { class: "account-info" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "Salutation", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lm-column" }, null, -1))
const _hoisted_17 = { class: "lm-row" }
const _hoisted_18 = { class: "lm-column" }
const _hoisted_19 = { class: "account-info" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "Name", -1))
const _hoisted_21 = { class: "lm-column" }
const _hoisted_22 = { class: "account-info" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "Surname", -1))
const _hoisted_24 = { class: "lm-row" }
const _hoisted_25 = { class: "lm-column" }
const _hoisted_26 = { class: "account-info" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "Street", -1))
const _hoisted_28 = { class: "lm-column" }
const _hoisted_29 = { class: "account-info" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "Street Number", -1))
const _hoisted_31 = { class: "lm-row" }
const _hoisted_32 = { class: "lm-column" }
const _hoisted_33 = { class: "account-info" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "Zip Code", -1))
const _hoisted_35 = { class: "lm-column" }
const _hoisted_36 = { class: "account-info" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "City", -1))
const _hoisted_38 = { class: "lm-row" }
const _hoisted_39 = { class: "lm-column" }
const _hoisted_40 = { class: "account-info" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "State", -1))
const _hoisted_42 = { class: "lm-column" }
const _hoisted_43 = { class: "account-info" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "Country", -1))
const _hoisted_45 = { class: "lm-row" }
const _hoisted_46 = { class: "lm-column" }
const _hoisted_47 = { class: "account-info" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "Email", -1))
const _hoisted_49 = { class: "lm-column" }
const _hoisted_50 = {
  key: 0,
  class: "account-info"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "Password", -1))
const _hoisted_52 = { style: {"display":"flex"} }
const _hoisted_53 = {
  key: 1,
  class: "account-info field-checkbox mail-validated"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "mailValidatedCheckbox" }, "Mail Validated", -1))
const _hoisted_55 = {
  key: 0,
  class: "lm-row"
}
const _hoisted_56 = { class: "lm-column" }
const _hoisted_57 = { class: "field-checkbox" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "mailValidatedCheckbox" }, "Mail Validated", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lm-column" }, null, -1))
const _hoisted_60 = { class: "lm-row" }
const _hoisted_61 = { class: "lm-column" }
const _hoisted_62 = { class: "field-checkbox" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "allowSendMailsCheckbox" }, "Send Notifications via Mail (e.g. product updates)", -1))
const _hoisted_64 = { class: "lm-column" }
const _hoisted_65 = { class: "account-info" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "Mails Roll Out Date", -1))
const _hoisted_67 = { class: "lm-row" }
const _hoisted_68 = { class: "lm-column" }
const _hoisted_69 = { class: "account-info" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "Account Type", -1))
const _hoisted_71 = { key: 0 }
const _hoisted_72 = { key: 1 }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { key: 1 }
const _hoisted_75 = { class: "lm-column" }
const _hoisted_76 = { class: "account-info" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "Confirmation Type", -1))
const _hoisted_78 = { class: "lm-row" }
const _hoisted_79 = { class: "lm-column" }
const _hoisted_80 = { class: "account-info" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "Stripe Customer ID", -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lm-column" }, null, -1))
const _hoisted_83 = { class: "update-actions" }
const _hoisted_84 = { key: 0 }
const _hoisted_85 = {
  align: "right",
  style: {"font-size":"small","font-style":"italic","color":"grey"}
}
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_87 = {
  key: 0,
  align: "right",
  style: {"font-size":"small","font-style":"italic","color":"grey"}
}
const _hoisted_88 = { class: "reactivate-acc" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "header" }, "Reactivate Account", -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "reactivate-acc-body" }, [
  /*#__PURE__*/_createElementVNode("h5", null, " The account you are trying to create already exists in the system, but it was deleted. You can reactivate it using old data or a new one. ")
], -1))
const _hoisted_92 = { class: "update-actions" }
const _hoisted_93 = {
  key: 1,
  class: "account-container"
}
const _hoisted_94 = { class: "header" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_96 = { class: "account-container-body" }
const _hoisted_97 = { class: "lm-row" }
const _hoisted_98 = { class: "lm-column" }
const _hoisted_99 = { class: "account-info" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "Company", -1))
const _hoisted_101 = { class: "lm-column" }
const _hoisted_102 = { class: "account-info" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "VAT", -1))
const _hoisted_104 = { class: "lm-row" }
const _hoisted_105 = { class: "lm-column" }
const _hoisted_106 = { class: "account-info" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "Salutation", -1))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lm-column" }, null, -1))
const _hoisted_109 = { class: "lm-row" }
const _hoisted_110 = { class: "lm-column" }
const _hoisted_111 = { class: "account-info" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "Name", -1))
const _hoisted_113 = { class: "lm-column" }
const _hoisted_114 = { class: "account-info" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "Surname", -1))
const _hoisted_116 = { class: "lm-row" }
const _hoisted_117 = { class: "lm-column" }
const _hoisted_118 = { class: "account-info" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "Street", -1))
const _hoisted_120 = { class: "lm-column" }
const _hoisted_121 = { class: "account-info" }
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "Street Number", -1))
const _hoisted_123 = { class: "lm-row" }
const _hoisted_124 = { class: "lm-column" }
const _hoisted_125 = { class: "account-info" }
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "Zip Code", -1))
const _hoisted_127 = { class: "lm-column" }
const _hoisted_128 = { class: "account-info" }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "City", -1))
const _hoisted_130 = { class: "lm-row" }
const _hoisted_131 = { class: "lm-column" }
const _hoisted_132 = { class: "account-info" }
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "State", -1))
const _hoisted_134 = { class: "lm-column" }
const _hoisted_135 = { class: "account-info" }
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "Country", -1))
const _hoisted_137 = { class: "lm-row" }
const _hoisted_138 = { class: "lm-column" }
const _hoisted_139 = { class: "account-info" }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info-label" }, "Email", -1))
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lm-column" }, null, -1))
const _hoisted_142 = { class: "lm-row" }
const _hoisted_143 = { class: "lm-column" }
const _hoisted_144 = { class: "field-checkbox" }
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "allowSendMailsCheckbox" }, "Send Notifications via Mail (e.g. product updates)", -1))
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lm-column" }, null, -1))
const _hoisted_147 = { class: "update-actions" }
const _hoisted_148 = { key: 0 }
const _hoisted_149 = { class: "reactivate-acc" }
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "header" }, "Reactivate Account", -1))
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "reactivate-acc-body" }, [
  /*#__PURE__*/_createElementVNode("h5", null, " The account you are trying to create already exists in the system, but it was deleted. You can reactivate it using old data or a new one. ")
], -1))
const _hoisted_153 = { class: "update-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_ChangePassword = _resolveComponent("ChangePassword")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.accountStore.isAdmin || _ctx.accountStore.isEmployee)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.modalHeader), 1),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_InputText, {
                  type: "text",
                  class: "form-control",
                  modelValue: _ctx.account.company,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.account.company) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_InputText, {
                  type: "text",
                  class: "form-control",
                  modelValue: _ctx.account.vat,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.account.vat) = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createVNode(_component_InputText, {
                  type: "text",
                  class: "form-control",
                  modelValue: _ctx.account.salutation,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.account.salutation) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _hoisted_16
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createVNode(_component_InputText, {
                  re: "",
                  type: "text",
                  class: _normalizeClass(["form-control", _ctx.getRequiredClass(_ctx.account.name)]),
                  modelValue: _ctx.account.name,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.account.name) = $event))
                }, null, 8, ["class", "modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createVNode(_component_InputText, {
                  type: "text",
                  class: _normalizeClass(["form-control", _ctx.getRequiredClass(_ctx.account.surname)]),
                  modelValue: _ctx.account.surname,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.account.surname) = $event))
                }, null, 8, ["class", "modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createVNode(_component_InputText, {
                  type: "text",
                  class: "form-control",
                  modelValue: _ctx.account.street,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.account.street) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createVNode(_component_InputText, {
                  type: "text",
                  class: "form-control",
                  modelValue: _ctx.account.streetNumber,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.account.streetNumber) = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _createVNode(_component_InputText, {
                  type: "text",
                  class: "form-control",
                  modelValue: _ctx.account.zipCode,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.account.zipCode) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createVNode(_component_InputText, {
                  type: "text",
                  class: "form-control",
                  modelValue: _ctx.account.city,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.account.city) = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createVNode(_component_InputText, {
                  type: "text",
                  class: "form-control",
                  modelValue: _ctx.account.state,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.account.state) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createVNode(_component_InputText, {
                  type: "text",
                  class: "form-control",
                  modelValue: _ctx.account.country,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.account.country) = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createVNode(_component_InputText, {
                    type: "text",
                    class: _normalizeClass(["form-control", _ctx.getRequiredClass(_ctx.account.email)]),
                    modelValue: _ctx.account.email,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.account.email) = $event))
                  }, null, 8, ["class", "modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                (!_ctx.account.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                      _hoisted_51,
                      _createElementVNode("div", _hoisted_52, [
                        _createVNode(_component_InputText, {
                          type: "password",
                          class: _normalizeClass(["form-control button-on-right-side", _ctx.getRequiredClass(_ctx.password)]),
                          modelValue: _ctx.password,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.password) = $event))
                        }, null, 8, ["class", "modelValue"]),
                        _createVNode(_component_Button, {
                          label: "Create Random Password",
                          class: _normalizeClass(["p-button p-component p-button-secondary", _ctx.getRequiredClass(_ctx.password)]),
                          onClick: _ctx.createRandomPassword,
                          style: {"border-top-right-radius":"290486px","border-bottom-right-radius":"290486px","width":"20rem","padding":"0px"}
                        }, null, 8, ["class", "onClick"])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_53, [
                      _createVNode(_component_Checkbox, {
                        inputId: "mailValidatedCheckbox",
                        modelValue: _ctx.account.emailConfirmed,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.account.emailConfirmed) = $event)),
                        binary: true
                      }, null, 8, ["modelValue"]),
                      _hoisted_54
                    ]))
              ])
            ]),
            (!_ctx.account.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, [
                      _createVNode(_component_Checkbox, {
                        inputId: "mailValidatedCheckbox",
                        modelValue: _ctx.account.emailConfirmed,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.account.emailConfirmed) = $event)),
                        binary: true
                      }, null, 8, ["modelValue"]),
                      _hoisted_58
                    ])
                  ]),
                  _hoisted_59
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _createVNode(_component_Checkbox, {
                  inputId: "allowSendMailsCheckbox",
                  modelValue: _ctx.account.allowSendMails,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.account.allowSendMails) = $event)),
                  binary: true
                }, null, 8, ["modelValue"]),
                _hoisted_63
              ])
            ]),
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("div", _hoisted_65, [
                _hoisted_66,
                _createVNode(_component_Datepicker, {
                  placeholder: "Mails Roll Out Date",
                  autoApply: "",
                  modelValue: _ctx.account.emailsRolloutDate,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.account.emailsRolloutDate) = $event)),
                  enableTimePicker: false
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _hoisted_70,
                (_ctx.accountStore.isAdmin)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                      _createVNode(_component_Dropdown, {
                        class: "form-control",
                        disabled: _ctx.editingCurrentUser,
                        modelValue: _ctx.account.role,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.account.role) = $event)),
                        options: _ctx.adminAccountRoles
                      }, null, 8, ["disabled", "modelValue", "options"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.accountStore.isEmployee)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                      (_ctx.account.id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                            _createVNode(_component_Dropdown, {
                              class: "form-control",
                              disabled: true,
                              modelValue: _ctx.account.role,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.account.role) = $event)),
                              options: _ctx.employeeReadOnlyAccountRoles
                            }, null, 8, ["modelValue", "options"])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_74, [
                            _createVNode(_component_Dropdown, {
                              class: "form-control",
                              modelValue: _ctx.account.role,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.account.role) = $event)),
                              options: _ctx.employeeAvailableAccountRoles
                            }, null, 8, ["modelValue", "options"])
                          ]))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_75, [
              _createElementVNode("div", _hoisted_76, [
                _hoisted_77,
                _createVNode(_component_Dropdown, {
                  class: "form-control",
                  modelValue: _ctx.account.accountConfirmationType,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.account.accountConfirmationType) = $event)),
                  options: _ctx.accountConfirmations
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_78, [
            _createElementVNode("div", _hoisted_79, [
              _createElementVNode("div", _hoisted_80, [
                _hoisted_81,
                _createVNode(_component_InputText, {
                  type: "text",
                  class: "form-control",
                  modelValue: _ctx.account.stripeCustomerId,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.account.stripeCustomerId) = $event)),
                  disabled: "true"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _hoisted_82
          ])
        ]),
        _createElementVNode("div", _hoisted_83, [
          (_ctx.account.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                _createVNode(_component_Button, {
                  label: "Change password",
                  class: "p-button-raised p-button-secondary p-button-text",
                  disabled: _ctx.isLoading,
                  onClick: _ctx.initChangePasswordModal
                }, null, 8, ["disabled", "onClick"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createVNode(_component_Button, {
              label: _ctx.account.id ? 'Update' : 'Create',
              class: "p-button-secondary p-button",
              disabled: _ctx.isLoading,
              onClick: _ctx.submitCreateUpdateForm
            }, null, 8, ["label", "disabled", "onClick"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_Button, {
              onClick: _ctx.cancelCreateUpdateForm,
              label: "Close",
              class: "p-button-secondary p-button-outlined"
            }, null, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_85, [
          _hoisted_86,
          _createElementVNode("span", null, [
            _createTextVNode(" Created by "),
            _createElementVNode("b", null, _toDisplayString(_ctx.account.createdBy), 1),
            _createTextVNode(" on "),
            _createElementVNode("b", null, _toDisplayString(_ctx.account.createdDate), 1)
          ])
        ]),
        (_ctx.account.modifiedBy != null && (_ctx.accountStore.isAdmin || _ctx.accountStore.isEmployee))
          ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
              _createElementVNode("span", null, [
                _createTextVNode(" Modified by "),
                _createElementVNode("b", null, _toDisplayString(_ctx.account.modifiedBy), 1),
                _createTextVNode(" on "),
                _createElementVNode("b", null, _toDisplayString(_ctx.account.modifiedDate), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_ModalComponent, { open: _ctx.showChangePasswordModal }, {
          body: _withCtx(() => [
            _createVNode(_component_ChangePassword, {
              account: _ctx.account,
              onCancel: _cache[22] || (_cache[22] = ($event: any) => (_ctx.showChangePasswordModal = false)),
              onClose: _cache[23] || (_cache[23] = ($event: any) => (_ctx.showChangePasswordModal = false))
            }, null, 8, ["account"])
          ]),
          _: 1
        }, 8, ["open"]),
        _createVNode(_component_ModalComponent, { open: _ctx.showReactivateModal }, {
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_88, [
              _hoisted_89,
              _hoisted_90,
              _hoisted_91,
              _createElementVNode("div", _hoisted_92, [
                _createElementVNode("div", null, [
                  _createVNode(_component_Button, {
                    onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.reactivateAcc(false))),
                    label: "Reactivate with old data",
                    class: "p-button-secondary p-button"
                  })
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_Button, {
                    onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.reactivateAcc(true))),
                    label: "Reactivate with new data",
                    class: "p-button-secondary p-button"
                  })
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_Button, {
                    onClick: _ctx.cancelReactivateForm,
                    label: "Cancel",
                    class: "p-button-secondary p-button-outlined"
                  }, null, 8, ["onClick"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["open"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_93, [
        _createElementVNode("h2", _hoisted_94, _toDisplayString(_ctx.modalHeader), 1),
        _hoisted_95,
        _createElementVNode("div", _hoisted_96, [
          _createElementVNode("div", _hoisted_97, [
            _createElementVNode("div", _hoisted_98, [
              _createElementVNode("div", _hoisted_99, [
                _hoisted_100,
                _createVNode(_component_InputText, {
                  type: "text",
                  class: "form-control",
                  modelValue: _ctx.account.company,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.account.company) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_101, [
              _createElementVNode("div", _hoisted_102, [
                _hoisted_103,
                _createVNode(_component_InputText, {
                  type: "text",
                  class: "form-control",
                  modelValue: _ctx.account.vat,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.account.vat) = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_104, [
            _createElementVNode("div", _hoisted_105, [
              _createElementVNode("div", _hoisted_106, [
                _hoisted_107,
                _createVNode(_component_InputText, {
                  type: "text",
                  class: "form-control",
                  modelValue: _ctx.account.salutation,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.account.salutation) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _hoisted_108
          ]),
          _createElementVNode("div", _hoisted_109, [
            _createElementVNode("div", _hoisted_110, [
              _createElementVNode("div", _hoisted_111, [
                _hoisted_112,
                _createVNode(_component_InputText, {
                  re: "",
                  type: "text",
                  class: _normalizeClass(["form-control", _ctx.getRequiredClass(_ctx.account.name)]),
                  modelValue: _ctx.account.name,
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.account.name) = $event))
                }, null, 8, ["class", "modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_113, [
              _createElementVNode("div", _hoisted_114, [
                _hoisted_115,
                _createVNode(_component_InputText, {
                  type: "text",
                  class: _normalizeClass(["form-control", _ctx.getRequiredClass(_ctx.account.surname)]),
                  modelValue: _ctx.account.surname,
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.account.surname) = $event))
                }, null, 8, ["class", "modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_116, [
            _createElementVNode("div", _hoisted_117, [
              _createElementVNode("div", _hoisted_118, [
                _hoisted_119,
                _createVNode(_component_InputText, {
                  type: "text",
                  class: "form-control",
                  modelValue: _ctx.account.street,
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.account.street) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_120, [
              _createElementVNode("div", _hoisted_121, [
                _hoisted_122,
                _createVNode(_component_InputText, {
                  type: "text",
                  class: "form-control",
                  modelValue: _ctx.account.streetNumber,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.account.streetNumber) = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_123, [
            _createElementVNode("div", _hoisted_124, [
              _createElementVNode("div", _hoisted_125, [
                _hoisted_126,
                _createVNode(_component_InputText, {
                  type: "text",
                  class: "form-control",
                  modelValue: _ctx.account.zipCode,
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.account.zipCode) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_127, [
              _createElementVNode("div", _hoisted_128, [
                _hoisted_129,
                _createVNode(_component_InputText, {
                  type: "text",
                  class: "form-control",
                  modelValue: _ctx.account.city,
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.account.city) = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_130, [
            _createElementVNode("div", _hoisted_131, [
              _createElementVNode("div", _hoisted_132, [
                _hoisted_133,
                _createVNode(_component_InputText, {
                  type: "text",
                  class: "form-control",
                  modelValue: _ctx.account.state,
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.account.state) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_134, [
              _createElementVNode("div", _hoisted_135, [
                _hoisted_136,
                _createVNode(_component_InputText, {
                  type: "text",
                  class: "form-control",
                  modelValue: _ctx.account.country,
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.account.country) = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_137, [
            _createElementVNode("div", _hoisted_138, [
              _createElementVNode("div", _hoisted_139, [
                _hoisted_140,
                _withDirectives((_openBlock(), _createElementBlock("div", null, [
                  _createVNode(_component_InputText, {
                    type: "text",
                    class: _normalizeClass(["form-control", _ctx.getRequiredClass(_ctx.account.email)]),
                    modelValue: _ctx.account.email,
                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.account.email) = $event)),
                    disabled: "true"
                  }, null, 8, ["class", "modelValue"])
                ])), [
                  [
                    _directive_tooltip,
                    'If you want to change your mail address, please reach out to support@presentaid.com',
                    void 0,
                    { top: true }
                  ]
                ])
              ])
            ]),
            _hoisted_141
          ]),
          _createElementVNode("div", _hoisted_142, [
            _createElementVNode("div", _hoisted_143, [
              _createElementVNode("div", _hoisted_144, [
                _createVNode(_component_Checkbox, {
                  inputId: "allowSendMailsCheckbox",
                  modelValue: _ctx.account.allowSendMails,
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.account.allowSendMails) = $event)),
                  binary: true
                }, null, 8, ["modelValue"]),
                _hoisted_145
              ])
            ]),
            _hoisted_146
          ])
        ]),
        _createElementVNode("div", _hoisted_147, [
          (_ctx.account.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                _createVNode(_component_Button, {
                  label: "Change password",
                  class: "p-button-raised p-button-secondary p-button-text",
                  disabled: _ctx.isLoading,
                  onClick: _ctx.initChangePasswordModal
                }, null, 8, ["disabled", "onClick"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createVNode(_component_Button, {
              label: _ctx.account.id ? 'Update' : 'Create',
              class: "p-button-secondary p-button",
              disabled: _ctx.isLoading,
              onClick: _ctx.submitCreateUpdateForm
            }, null, 8, ["label", "disabled", "onClick"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_Button, {
              onClick: _ctx.cancelCreateUpdateForm,
              label: "Close",
              class: "p-button-secondary p-button-outlined"
            }, null, 8, ["onClick"])
          ])
        ]),
        _createVNode(_component_ModalComponent, { open: _ctx.showChangePasswordModal }, {
          body: _withCtx(() => [
            _createVNode(_component_ChangePassword, {
              account: _ctx.account,
              onCancel: _cache[39] || (_cache[39] = ($event: any) => (_ctx.showChangePasswordModal = false)),
              onClose: _cache[40] || (_cache[40] = ($event: any) => (_ctx.showChangePasswordModal = false))
            }, null, 8, ["account"])
          ]),
          _: 1
        }, 8, ["open"]),
        _createVNode(_component_ModalComponent, { open: _ctx.showReactivateModal }, {
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_149, [
              _hoisted_150,
              _hoisted_151,
              _hoisted_152,
              _createElementVNode("div", _hoisted_153, [
                _createElementVNode("div", null, [
                  _createVNode(_component_Button, {
                    onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.reactivateAcc(false))),
                    label: "Reactivate with old data",
                    class: "p-button-secondary p-button"
                  })
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_Button, {
                    onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.reactivateAcc(true))),
                    label: "Reactivate with new data",
                    class: "p-button-secondary p-button"
                  })
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_Button, {
                    onClick: _ctx.cancelReactivateForm,
                    label: "Cancel",
                    class: "p-button-secondary p-button-outlined"
                  }, null, 8, ["onClick"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["open"])
      ]))
}